import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AuthenticationService, ListsService, CatalogService, HeaderService } from 'src/app/_services';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingList, ShoppingListLine } from 'src/app/_models';
import { ProductDetailModalComponent } from 'src/app/products/product-detail-modal/product-detail-modal.component';
import { LineToLineMappedSource } from 'webpack-sources';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { BasketService } from 'src/app/_services/basket.service';
import { DomSanitizer } from '@angular/platform-browser';

declare const $ :any;

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  @Input()  listId : number ;
  public list : ShoppingList;

  @ViewChild(ProductDetailModalComponent) productDetailModal: ProductDetailModalComponent; 
  
  constructor(
    private header : HeaderService,
    public apps : ApplicationStateService,
    private listss : ListsService,
    private translate : TranslateService,
    private route : ActivatedRoute,
    private spinner: NgxSpinnerService,
    public router : Router,
    public catalog : CatalogService,
    private basket : BasketService,
    public dom : DomSanitizer
  ) {
    
    this.route.params.subscribe( result =>{
      this.listId = result.listId;
      this.header.scrollTop();
      this.loadData();
    });
   }

  ngOnInit() {   
  }

  loadData() {
      setTimeout(() => {
        this.spinner.show();
      }, environment.READY_TIMEOUT);

      this.listss.get(this.listId, this.translate.currentLang).subscribe( 
        result =>{
          this.list = result;
          setTimeout(() => {
            this.spinner.hide();
          }, environment.READY_TIMEOUT);
        }, error =>{
          this.list = null;
          setTimeout(() => {
            this.spinner.hide();        
          }, environment.READY_TIMEOUT);
      });

  }

  productDetail(itemId : string){
    $('#modal-product-detail').modal('show');
    this.productDetailModal.itemId = itemId;
    this.productDetailModal.loadData();
  }

  more(line : ShoppingListLine){
    this.listss.addLine(this.listId, line.lineid, line.product, line.quantity +1).subscribe(result =>{
        this.loadData();
      });
  }

  less(line : ShoppingListLine){
    if (line.quantity > 1){
      this.listss.addLine(this.listId, line.lineid, line.product, line.quantity - 1 ).subscribe( result =>{
        this.loadData();
      });
    }
  }

  remove ( line : ShoppingListLine ){
    this.listss.deleteLine(this.listId, line.lineid).subscribe(result =>{
        this.listss.get(this.listId, this.translate.currentLang).subscribe(result =>{
          this.list = result;
        });
    });
  }
  
  onConfirm(id: number){
      this.listss.delete(id).subscribe(result =>{
        if (this.listss.userListsSubject.value.length > 0){
          this.router.navigate(['/user/list/' + this.listss.userListsSubject.value[0].id]);
        } else {
          this.router.navigate(['/user/edit']);
        }       
        $('#modal-confirm-' + this.listId).modal('hide');
      });
  }

  onAdd2Cart(){
    if (this.list){
      setTimeout(() => {
        this.spinner.show();
      }, environment.READY_TIMEOUT);

      this.basket.addFromList(this.list).subscribe(
        result => {
          $('#modal-message-' + this.listId).modal('show');
        }, 
        error =>{
        },
        () => {
          setTimeout(() => {
            this.spinner.hide();
          }, environment.READY_TIMEOUT); 
        }
      );
    }

  }

  onListRename (){
    this.loadData();
  }

}
